import Schema from 'AppReact/schema';
import { assignTech, assignVendor } from 'types';

export default {
  startTime: Schema('jsDate', 'primitive'),
  endTime: Schema('jsDate', 'primitive'),
  assignedTechId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  assignedVendorId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  techs: Schema(assignTech, 'array', { defaultValue: [] }),
  vendors: Schema(assignVendor, 'array', { defaultValue: [] }),
  startH: Schema('string', 'primitive-nullable', { defaultValue: null }),
  endH: Schema('string', 'primitive-nullable', { defaultValue: null }),
  isEditing: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  assigneeName: Schema('string', 'primitive-nullable', { defaultValue: null }),
}